import { Controller } from "@hotwired/stimulus"

// German forms a renamed core entity usually takes, from its singular and gender. Only a
// suggestion: the fields stay editable and the server never relies on it.
export function suggestGermanForms(one, gender) {
  const word = one.trim()
  if (!word || !gender) return {}

  if (gender === "f") {
    const endsInE = word.endsWith("e")
    return {
      other: endsInE ? `${word}n` : `${word}en`,
      gen: word,
      stem: endsInE ? `${word}n` : word,
    }
  }

  // der Auftrag/des Auftrags, das Projekt/des Projekts; -er/-el/-en nouns keep their plural, and a
  // word ending in a hissing sound takes -es (der Einsatz/des Einsatzes).
  const keepsPlural = /(er|el|en)$/.test(word)
  const gen = /(s|ß|x|z)$/.test(word) ? `${word}es` : `${word}s`
  return { other: keepsPlural ? word : `${word}e`, gen, stem: word }
}

// One card on the Begriffe page: the own-word fields only show while "Eigener Begriff" is chosen,
// and typing a singular fills the other German forms the user has not written themselves.
export default class extends Controller {
  static targets = ["choice", "custom", "one", "gender", "other", "gen", "stem"]
  static values = { custom: String }

  toggle() {
    this.customTarget.classList.toggle("hidden", this.choiceTarget.value !== this.customValue)
  }

  suggest() {
    const suggestion = suggestGermanForms(this.oneTarget.value, this.genderTarget.value)
    for (const form of ["other", "gen", "stem"]) {
      const field = this[`${form}Target`]
      // Overwrite only what is empty or still our own last suggestion, never a typed word.
      if (field.value === "" || field.value === field.dataset.suggested) {
        field.value = suggestion[form] ?? ""
        field.dataset.suggested = field.value
      }
    }
  }
}
